<template>
<div>
<div class="wrapper-shopify">
	<div class="">
		<button class="create-new-program button-inside" @click="open_new_modal = true"> <img class="mr-1" id="" src="../../assets/images/u52_plus.svg" width="22" /> Create new program</button>
	</div>
	<div class="drafts">
		<div class="draft-title"> Drafts </div>
		<div class="draft-list">
			<div v-for="(draft,index) in drafts" :key="index">
					
				<div class="rectangle-outside">
				
					<div class="rectangle-holder">
						<div class="rectangle-wrapper">
							<img  width="20" src="../../assets/images/icons/solid/pencil-alt-green.svg" 
				       			@click="openDraft(draft)"
								class="cursor-pointer edit-icon-pencil" />
							<img  width="16" src="../../assets/images/icons/solid/trash-alt.svg" 
				            	class="trash-icon"  @click="openEditModal(draft)"
				            />
						<a class="pointer" @click="openDraft(draft)">

								<div class="title-rectangle">
									{{draft.name}}
								</div>
								<div class="rectangle-notes">
									{{draft.notes}}
								</div>
							</a>
							</div>
						<a class="pointer" @click="openDraft(draft)">
							<div class="blue-time-date-drafts">
								{{draft.created_at}}	{{draft.created_at_time}} <span class="float-right">ID - {{draft.id}} </span>
							</div>
						</a>
					</div>
				
			</div>
		</div>
		</div>
	</div>
	<div class="completed">
		<div class="draft-title"> Completed </div>
		<div class="draft-list">
			<div v-for="(comp,index) in completed" :key="index">
				<div class="rectangle-outside completed-height-rectangle">
					
					<div class="rectangle-holder">
						<div class="rectangle-wrapper rectangle-wrapper-completed">
							<div class="title-rectangle">
								{{comp.name}}
							</div>
							<div class="blue-module-duration-drafts">
							{{secondsToHms((comp.duration), true)}} <span class="color-grey">•</span>	{{comp.modules.length}} Module
							</div>
							<div class="rectangle-notes notes-completed">
								{{comp.notes}}
							</div>
						</div>
						<div class="blue-time-date-completed">
							{{comp.completed_at}} <span class="float-right">ID - {{comp.id}}</span>
							 
						</div>
					</div>

			</div>
		</div>
		</div>
	</div>
	<b-modal v-model="open_new_modal"  title="Small Modal" hide-header hide-footer @hide="onHide">
		<div class="modal-section">
			<div class="modal-title-blue-program">
				{{modal_title}}
			</div>
			<div>
				<div class="input-modal">
					<input type="text" v-validate="'required'" v-model="new_user_program.name" name="program_name" class="no-border"  placeholder="Program Name"/>
					<span class="input-error-msg">{{ errors.first('program_name') }}</span>
				</div>
			</div>
			<div class="inputmodal-notes">
				<textarea class="inputmodal-textarea no-border" v-model="new_user_program.notes" placeholder="Notes"></textarea>
			</div>
		
			<button :class="{'button-disabled': new_user_program.program_name == ''}" class="modal-ok-button" @click="createProgram">Create</button>
		</div>
	</b-modal>


	</div>


	<div v-if="show_remove_module">
		  <remove-module-dialog :remove_modal="show_remove_module"  
            :modalToRemove="modal_to_remove"
            @removeModuleFromChart="deleteProgram"
			@closeModal="closeModalDelete"
            :modal_view="true"></remove-module-dialog>
	</div>
</div>
	
</template>
<script>
import MixinSME from '../sme/MixinSME';
import RemoveModuleDialog from './RemoveModuleDialog'

export default {
	components : {
		RemoveModuleDialog
	},
	mixins: [MixinSME],
	data : function(){
		return{
			drafts: [],
			completed: [],
			open_new_modal:false,
			new_user_program:{
				name:'',
				notes:'',
				description:''
			},
			modal_title: 'New Program',
			modal_button_text: 'Create',
			show_remove_module: false,
			modal_to_remove:''
		}
	},
	created : function(){
		this.getDrafts()
		this.getCompletedPrograms()
	},
	methods:{
		getDrafts: function(){
			var params = {
                filters : {
                    // full:true,
                     page : 1
				}
            }
            this.$store.dispatch('getDrafts', params).then((res) => {
              this.drafts = res.data.data

            }).catch((error) => {
                console.log(error);
            });
		},
		getCompletedPrograms: function(){
			var params = {
                filters : {
                    // full:true,
                     page : 1
				}
            }
            this.$store.dispatch('getCompletedPrograms', params).then((res) => {
              this.completed = res.data.data

            }).catch((error) => {
                console.log(error);
            });


		},
		createProgram: function(){
			this.$validator.validateAll().then((result) => {
				if(result){
					var params = this.new_user_program;
					console.log(params)
					this.$store.dispatch('createDraft', params).then((res)=>{
						this.open_new_modal = false
					this.$router.push({ name : 'shopify.list', params: { id : res.data.course.id }},);
					})
				}
			})
		},
		deleteProgram: function(draft){
			var params = draft;
			this.$store.dispatch('deleteCourse', params).then((res)=>{
				this.closeModalDelete()
				this.getDrafts()
			})
		},
		openDraft: function(draft){
			this.$router.push({ name : 'shopify.list', params: { id : draft.id }},);

		},
		openEditModal: function(draft){
			this.modal_to_remove = draft
			this.show_remove_module = true
		},
		closeModalDelete: function(){
			this.modal_to_remove = ''
			this.show_remove_module = false
		},
		onHide: function(){
			this.new_user_program = {
				name:'',
				notes:'',
				description:''
			}
			this.modal_title = 'New Program'
			this.modal_button_text = 'Create'
		}
	}
}
</script>

<style scoped src="./Shopify.css">

</style>



// WEBPACK FOOTER //
// src/components/shopify/ShopifyDraftsandPrograms.vue